import { render } from "./SpotifyPlayer.vue?vue&type=template&id=46847f25"
import script from "./SpotifyPlayer.vue?vue&type=script&lang=js"
export * from "./SpotifyPlayer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__